import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0
    
}
const mutations={
   
  
    getUserAddress(state,value){
        
        
       
        post(urls.admin.address.get_user_address,value).then((result)=>{
          
          
          
          state.result=result
        
       
        
       
           
        });
        
    },
  
    
   

    

}
const  actions={
    getUserAddressAction(context,value){
       
        context.commit("getUserAddress",value)
       
    },
  
  
    
   

}

export default {state,mutations,actions}